export const validateEmailFormat = (email: string): boolean =>
    relodeConstants.EMAIL_VALIDATION_REGEX.test(email);

export const validateNonIndeedEmail = (email: string): boolean =>
    !relodeConstants.INDEED_EMAIL_VALIDATION_REGEX.test(email);

export const validateEmail = (email: string): boolean =>
    validateEmailFormat(email) && validateNonIndeedEmail(email);
